export const cognitoConfig = {
    UserPoolId: "us-east-1_TfjfDvjWz",
    ClientId: "2vda7vg7ocfp0q58k3d5g8aj9h",
}